import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Nav as BoostrapNav } from "react-bootstrap";

import Link from "../Link";
import "./styles.scss";

const Nav = ({ items, className, children, renderItem, ...restProps }) => {
  const node = React.useMemo(() => children || items.map(renderItem), [
    items,
    children,
  ]);
  return (
    <BoostrapNav className={classNames("mydpd-nav", className)} {...restProps}>
      {node}
    </BoostrapNav>
  );
};

Nav.defaultProps = {
  renderItem: ({ href, eventKey, name, ...rest }, index) => (
    <Link
      key={index}
      eventKey={eventKey || index}
      href={href}
      name={name}
      {...rest}
    />
  ),
};

Nav.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  renderItem: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      eventKey: PropTypes.string,
      name: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ),
};

export default Nav;
